import { render } from "./newDirectionComponent.vue?vue&type=template&id=c3f92348"
import script from "./newDirectionComponent.vue?vue&type=script&lang=js"
export * from "./newDirectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__